import {
  finishUserSignup as _finishUserSignup,
  FinishUserSignupPayload,
} from '@griply/services';
import { Locales } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';
import { UtmParameters } from 'shared/types/utm-parameters';
import { getCookie } from 'shared/utils/get-cookie';

import { getFunctions } from './helpers';

export type Options = {
  uid?: ID | null;
  name?: string;
  locale?: Locales;
  hasNotifications?: boolean;
  queryParameters?: Partial<Record<UtmParameters | QueryParamOptions, string>>;
};

const getSource = (): string => {
  if (window.electron?.isMac) {
    return 'mac_app';
  }
  if (window.electron?.isWindows) {
    return 'win_app';
  }
  return 'web_app';
};

export const finishUserSignup = async ({
  uid,
  name,
  locale,
  hasNotifications,
  queryParameters,
}: Options) => {
  try {
    const payload: FinishUserSignupPayload = {
      name,
      locale,
      hasNotifications,
      queryParameters: (queryParameters ?? {}) as Record<string, string>,
      source: getSource(),
      _fprom_tid: getCookie('_fprom_tid'),
    };
    await _finishUserSignup({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });

    // TODO: review whether this Sentry Logs / metric capture is useful before keeping it.
    // Sentry deprecated the legacy `Sentry.metrics.increment` API in v10 — this routes through
    // Sentry Logs (`Sentry.logger.info`) which is the current replacement. Remove the call if
    // you don't want signup telemetry, or change the metric name / dimensions to suit.
    getErrorReporter().increment('user.signup_completed', 1, {
      source: payload.source ?? 'unknown',
    });
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'finish-user-signup', uid: uid ?? undefined },
    });
  }
};
